import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { InputMintDiv } from 'views/common-styled-components';
import { fetchGetProfileView } from '../../profile-view.actions';
import { getEncryptedUserId } from '__utils/common-utils';
import ProfileViewSelector from '../../profile-view.selector';
import { propsToJS } from '__utils/immutable-to-js';
import { useDispatch, useSelector } from 'react-redux';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { Row, Col } from 'antd';
import { LayoutContext } from 'components/app-routes';
import { PersonalInfoTab, ProfileSubmitButton } from '../personal-account-info/style';
import { DASHBOARD_NOMINEE_INPUTS, PROFILE_ONBOARDING_CTA, PROFILE_TABS, stringifyNumber } from '../constants';
import CustomAccordion from 'components/custom-antd-accordion';
import user from 'images/user.svg';
import { CaretUpOutlined } from '@ant-design/icons';
import { COLOR } from 'constants/colors';
import { WarningIcon } from 'assets/icons/warning-icon';
import DisclaimerBox from 'components/disclaimer-box';
import './index.css';
import { NOMINEE_AUTHENTICATION_LINK } from 'constants/common-links';
import MobileFooterLayout from 'components/old-footer-layout';
import { MY_PROFILE_HEADER } from 'constants/header-titles';
import { relationshipMap } from 'constants/common-constants';

const NomineeInfo: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    // eslint-disable-next-line
    const { SetLayoutProps } = React.useContext(LayoutContext);
    const { profileView } = propsToJS(useSelector(ProfileViewSelector));
    const [nomineeList, setNomineeList] = useState([{ nomineeName: '', relationship: '', nomineePercentage: '' }]);

    useEffect(() => {
        SetLayoutProps({
            config: { title: MY_PROFILE_HEADER }
        })
        dispatch(fetchGetProfileView(getEncryptedUserId()));
        Mixpanel.track(getEventName("nomineeDetails", "loaded", "profile"));
    }, [])

    useEffect(() => {
        if (profileView?.nomineeList) {
            setNomineeList(profileView?.nomineeList)
        }
    }, [useDeepCompare(profileView)]);

    return (<div>
        <PersonalInfoTab>

            <div className='disclaimer-txt'>
                <DisclaimerBox
                    bgCol={COLOR.WARNING_LIGHT}
                    icon={<WarningIcon />}
                    text={<p>Please note that the nomination details can't be edited on the profile page. Visit this <a href={NOMINEE_AUTHENTICATION_LINK} target='_blank'>link</a> page to make changes.</p>}
                />
            </div>
            {isMobile && <div>
                <h3>{PROFILE_TABS[3].label}</h3>
            </div>}

            <form>
                {<div>
                    {
                        nomineeList.map((nominee: any, index: number) =>
                        (
                            <>< CustomAccordion
                                key={index}
                                defaultActiveKey={['0']}
                                header={< label className='boldFt16' > <img src={user} />  {stringifyNumber(index)} Nominee</label>}
                                children={<Row gutter={[32, 16]}>
                                    {
                                        DASHBOARD_NOMINEE_INPUTS.map((inputElement, index) => (<Col xs={24} md={12} key={index}>
                                            <InputMintDiv>
                                                <label>{inputElement.title}</label>
                                                <br />
                                                <input
                                                {...inputElement}
                                                value={
                                                    inputElement.title === "Relationship with Nominee"
                                                        ? relationshipMap[nominee[inputElement.name]] || nominee[inputElement.name]
                                                        : nominee[inputElement.name]
                                                }
                                                defaultValue={nominee[inputElement.name]}
                                                />
                                            </InputMintDiv>
                                        </Col>))
                                    }
                                </Row>}
                                index={index}
                                expandIconPosition='right'
                                expandIcon={({ isActive }) => <CaretUpOutlined rotate={isActive ? 0 : 180} />}

                            />
                                <hr /></>
                        ))
                    }
                </div>}
            </form >
            <div className='account-btn-wrapper'>
                {profileView?.registeredWithBse !== 3 && <ProfileSubmitButton onClick={() => history.push('/profile/kyc-details?flowType=checkout')} isMobile={isMobile} type="button">{PROFILE_ONBOARDING_CTA}</ProfileSubmitButton>}
            </div>
            <MobileFooterLayout />
        </PersonalInfoTab >
    </div >);
};

export default NomineeInfo;

